/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import AppHeader from 'app/containers/parts/AppHeader';

type Props = {
  children?: any,
  showAd?: boolean,
  title?: string
};

const defaultProps = {
  children: undefined,
  showAd: false,
  title: undefined
};

const FullWidthPage = glamorous.div(props => ({
  [props.theme.mediaQuery.desktopAndUp]: {
    marginLeft: '12vw',
    marginRight: '12vw'
  }
}));

function FullPage({ children, showAd, title }: Props) {
  return (
    <FullWidthPage>
      <AppHeader showAd={showAd} title={title} />
      {children}
    </FullWidthPage>
  );
}

FullPage.defaultProps = defaultProps;

export default FullPage;
